import flatpickr from 'flatpickr';
import config from '@/config';
import { dateInBetween } from '@/modules/dates';

export default {
  props: {
    bus: {
      type: Object,
      default: null,
      required: false
    }
  },

  computed: {
    columnsDateInputs() {
      const dateColumns = this.columns.filter(column => column.type === 'date');
      const dateInputs = [];

      dateColumns.forEach(column => {
        if (column.filterOptions) {
          dateInputs.push(
            `input[placeholder='${column.filterOptions.placeholder}']`
          );
        }
      });

      return dateInputs;
    }
  },

  methods: {
    resetFilters() {
      this.columns.forEach((value, key) => {
        if (this.columns[key].filterOptions) {
          this.$set(this.columns[key].filterOptions, 'filterValue', false);
          this.$set(this.columns[key].filterOptions, 'filterValue', '');
        }
      });
      this.$nextTick(() => {
        this.columnsDateInputs.forEach(input =>
          this.flatpickrInit(input, 'range')
        );
      });
      this.$nextTick(() => {
        this.clearFilteredRows(this.$refs.table.$el);
      });
    },

    findFilteredRows(el) {
      return el.querySelectorAll('input.vgt-input, select.vgt-select');
    },

    clearFilteredRows(el) {
      const filters = this.findFilteredRows(el);
      filters.forEach(input =>
        input.parentNode.parentNode.classList.remove('filtered')
      );
    },

    decorateFilteredRows(el) {
      const filters = this.findFilteredRows(el);
      filters.forEach(input => {
        if (input.value !== '') {
          input.parentNode.parentNode.classList.add('filtered');
        } else {
          input.parentNode.parentNode.classList.remove('filtered');
        }
      });
    },

    sortBySize(x, y, col, rowX, rowY) {
      if (rowX.width < rowY.width) {
        return -1;
      } else if (rowX.width > rowY.width) {
        return 1;
      } else {
        if (rowX.height < rowY.height) {
          return -1;
        } else if (rowX.height > rowY.height) {
          return 1;
        } else {
          if (rowX.depth < rowY.depth) {
            return -1;
          } else if (rowX.depth > rowY.depth) {
            return 1;
          } else {
            return 0;
          }
        }
      }
    },

    dateRangeFilter(date, filterString) {
      return dateInBetween(date, filterString);
    },

    onColumnFilter() {
      this.decorateFilteredRows(this.$refs.table.$el);
    },

    flatpickrInit(input, mode) {
      flatpickr(input, {
        altInput: true,
        altFormat: config.flatpickr.dateOutputFormat,
        dateFormat: config.flatpickr.dateTimeInputFormat,
        mode: !mode ? 'single' : mode,
        onReady(dateObj, dateStr, instance) {
          const $cal = instance.calendarContainer;

          if ($cal.querySelector('.flatpickr-clear')) {
            const $clear = $cal.querySelector('.flatpickr-clear');
            $clear.addEventListener('click', () => {
              instance.clear();
              instance.close();
            });
          } else {
            const $div = document.createElement('div');
            $div.className = 'flatpickr-clear';
            $div.innerHTML = 'Очистить';
            $cal.appendChild($div);

            $div.addEventListener('click', () => {
              instance.clear();
              instance.close();
            });
          }
        }
      });
    }
  },

  mounted() {
    this.columnsDateInputs.forEach(input => this.flatpickrInit(input, 'range'));
    if (this.bus) {
      this.bus.$on('RESET', () => {
        this.resetFilters();
      });
    }
  }
};
